import type { FeatureFlagService } from "../services/feature-flags";
import type { TrainingModule, ModuleView } from "../modules/types";
import { resolveModuleView } from "../modules/types";

export interface ShellView {
  readonly modules: readonly ModuleView[];
  readonly title: "ATLas";
}

export function buildShellView(
  modules: readonly TrainingModule[],
  flags: FeatureFlagService,
): ShellView {
  return {
    title: "ATLas",
    // A module whose flag is off yields no view at all, so the shell has
    // nothing to render for it. Hard rule 7, 17 October 2026 (a).
    modules: modules
      .map((module) => resolveModuleView(module, flags))
      .filter((view): view is ModuleView => view !== null),
  };
}
